import tabaComponent from './taba.component';

const tabaModule = angular.module('taba', [
])
  .component('taba', tabaComponent)
  .name;

export default tabaModule;
